/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["agm-map[_ngcontent-%COMP%] {\n  height: 300px; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9vcHQvYXRsYXNzaWFuL3BpcGVsaW5lcy9hZ2VudC9idWlsZC9zcmMvYXBwL3BhZ2VzL3dpdGhvdXQtbG9naW4vdmlldy1tZHIvZ2VvbG9jYXRpb24vZ2VvbG9jYXRpb24uY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0E7RUFDRSxhQUFhLEVBQUEiLCJmaWxlIjoic3JjL2FwcC9wYWdlcy93aXRob3V0LWxvZ2luL3ZpZXctbWRyL2dlb2xvY2F0aW9uL2dlb2xvY2F0aW9uLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG5hZ20tbWFwIHtcbiAgaGVpZ2h0OiAzMDBweDtcbn1cbiJdfQ== */"];
export { styles as styles };
